module.exports = __webpack_public_path__ + "img/oneGreen.4d761fc4.png";